import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_ACCOUNT_TMS_DRIVERS_BY_CARRIER_ID, GetAccountTmsDriversByCarrierIdResponse } from '../schedule/graphql/queries/getAccountTmsDriversByCarrierId';
import { TmsStatusEnum } from 'enums/TmsEnum';

/**
 * TMS根据承运商ID获取司机Hook
 * 根据承运商ID获取该承运商下的司机列表
 */
export const useTmsDriversByCarrier = (carrierId: number | string | null | undefined) => {
    // 根据承运商ID获取司机，限制状态为Active
    const { data: driversData, loading: driversLoading } = useQuery<GetAccountTmsDriversByCarrierIdResponse>(
        GET_ACCOUNT_TMS_DRIVERS_BY_CARRIER_ID,
        {
            variables: { 
                carrierId: carrierId ? Number(carrierId) : null, 
                status: TmsStatusEnum.Active 
            },
            skip: !carrierId
        }
    );

    // 根据承运商ID获取司机选项
    const driverOptions = useMemo(() => {
        if (!driversData?.getAccountTmsDriversByCarrierId) return [];
        return driversData.getAccountTmsDriversByCarrierId.map(driver => ({
            label: driver.driverName || '',
            value: driver.id.toString() // 使用 AccountTmsDriver 的 id
        }));
    }, [driversData]);

    return {
        driverOptions,
        driversData,
        driversLoading
    };
};
